/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import DyteClient from '@dytesdk/web-core';
import { DyteI18n, useLanguage } from '../lib/lang';
import { defaultIconPack, IconPack } from '../lib/icons';
import DyteText from './DyteText';
import { useDyteSelector } from '@dytesdk/react-native-core';
import { DyteUIContext } from '../lib/context-provider/ui-context';

const addZero = (num) => {
  return Math.floor(num).toString().padStart(2, '0');
};

export default function ({
  meeting,
  iconPack = defaultIconPack,
  t,
}: {
  meeting: DyteClient;
  iconPack?: IconPack;
  t?: DyteI18n;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const defaultLang = useLanguage();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  t = t ?? defaultLang;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  iconPack = iconPack ?? defaultIconPack;
  const { meetingStartedTimestamp } = useDyteSelector((m) => m.meta);
  const stage = useDyteSelector((m) => m.stage);
  const requestRef = useRef<number>();
  const timeRef = useRef<NodeJS.Timeout>();
  const [time, setTime] = useState('');
  const setFormattedTime = (timeDiff) => {
    if (timeDiff == null) {
      return null;
    }
    let timeString = '';
    const hours = addZero(timeDiff / 3600);
    const minutes = addZero((timeDiff % 3600) / 60);
    const seconds = addZero(timeDiff % 60);
    if (timeDiff >= 3600) {
      timeString = `${hours}:${minutes}:${seconds}`;
    } else {
      timeString = `${minutes}:${seconds}`;
    }
    setTime(timeString);
  };
  const startedTimeChanged = (startedTime: string) => {
    if (startedTime !== '') {
      const animate = () => {
        const timeDiff = (Date.now() - new Date(startedTime).getTime()) / 1000;
        setFormattedTime(timeDiff);
        timeRef.current = setTimeout(() => {
          if (requestRef.current != null) {
            requestRef.current = requestAnimationFrame(animate);
          }
        }, 500);
      };
      requestRef.current = requestAnimationFrame(animate);
    }
  };
  useEffect(() => {
    if (meetingStartedTimestamp !== undefined) {
      startedTimeChanged(meetingStartedTimestamp.toISOString());
    }
    return () => {
      timeRef.current && clearTimeout(timeRef.current);
      typeof requestRef.current === 'number' &&
        cancelAnimationFrame(requestRef.current);
    };
  }, [meeting]);
  const shouldNotDisplaySeparator =
    (meeting.meta.viewType === 'WEBINAR' && stage.status === 'OFF_STAGE') ||
    (meeting.meta.viewType === 'LIVESTREAM' &&
      meeting.stage.status !== 'ON_STAGE');
  const styles = StyleSheet.create({
    container: {
      padding: 4,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-evenly',
    },
    textStyle: {
      color: colors.text,
    },
  });
  if (meeting.meta.viewType === 'LIVESTREAM') return null;
  return (
    <View style={styles.container}>
      {!shouldNotDisplaySeparator && <DyteText size="sm">. </DyteText>}
      <DyteText size="sm" style={styles.textStyle}>
        {time}
      </DyteText>
    </View>
  );
}
